[
  {
    "id": "cmentarz",
    "name": "Przeklęty Cmentarz",
    "description": "Stare groby, z których coś wciąż wypełza. Dobre miejsce na początek.",
    "visual": "cmentarz",
    "difficulty": 1,
    "healthMultiplier": 1,
    "rewardMultiplier": 1,
    "enemies": [
      {
        "enemy": "szkielet-sluga",
        "weight": 10
      },
      {
        "enemy": "kostny-lotr",
        "weight": 6
      },
      {
        "enemy": "nieumarly-mag",
        "weight": 4
      },
      {
        "enemy": "kosciany-kolos",
        "weight": 1
      },
      {
        "enemy": "kostny-strzelec",
        "weight": 3
      },
      {
        "enemy": "plonaca-czaszka",
        "weight": 2
      },
      {
        "enemy": "kostny-taran",
        "weight": 1
      }
    ],
    "obstacles": 4,
    "bosses": [
      {
        "enemy": "krol-kosci",
        "at": 240
      },
      {
        "enemy": "pradawny-nekromanta",
        "at": 600,
        "final": true
      }
    ],
    "hazards": {
      "kind": "trucizna",
      "perChunk": 1,
      "radius": [
        34,
        52
      ],
      "damagePerSecond": 3,
      "slow": 0
    },
    "breakables": 2,
    "recommendedPower": 0
  },
  {
    "id": "las",
    "name": "Jesienny Las",
    "description": "Gęsty las pełen kościanych zwiadowców i magów. Wrogowie są twardsi, ale łupy większe.",
    "visual": "las",
    "difficulty": 2,
    "healthMultiplier": 1.5,
    "rewardMultiplier": 1.6,
    "enemies": [
      {
        "enemy": "kostny-lotr",
        "weight": 8
      },
      {
        "enemy": "nieumarly-mag",
        "weight": 6
      },
      {
        "enemy": "szkielet-sluga",
        "weight": 4
      },
      {
        "enemy": "kosciany-kolos",
        "weight": 2
      },
      {
        "enemy": "kostny-strzelec",
        "weight": 5
      },
      {
        "enemy": "plonaca-czaszka",
        "weight": 3
      },
      {
        "enemy": "kostny-taran",
        "weight": 2
      }
    ],
    "obstacles": 6,
    "bosses": [
      {
        "enemy": "pradawny-nekromanta",
        "at": 210
      },
      {
        "enemy": "krol-kosci",
        "at": 420
      },
      {
        "enemy": "pradawny-nekromanta",
        "at": 600,
        "final": true
      }
    ],
    "hazards": {
      "kind": "trucizna",
      "perChunk": 2,
      "radius": [
        30,
        48
      ],
      "damagePerSecond": 6,
      "slow": 0.15
    },
    "breakables": 2,
    "recommendedPower": 800
  },
  {
    "id": "ruiny",
    "name": "Zamarznięte Ruiny",
    "description": "Skute lodem ruiny dawnej twierdzy. Szron spowalnia kroki, a w zamieci czają się najtwardsi umarli.",
    "visual": "ruiny",
    "difficulty": 3,
    "healthMultiplier": 2.1,
    "rewardMultiplier": 2.3,
    "obstacles": 5,
    "enemies": [
      {
        "enemy": "szkielet-sluga",
        "weight": 4
      },
      {
        "enemy": "kostny-lotr",
        "weight": 6
      },
      {
        "enemy": "oszroniony-wojownik",
        "weight": 5
      },
      {
        "enemy": "mrozny-mag",
        "weight": 5
      },
      {
        "enemy": "kostny-strzelec",
        "weight": 3
      },
      {
        "enemy": "kosciany-kolos",
        "weight": 2
      },
      {
        "enemy": "kostny-taran",
        "weight": 2
      }
    ],
    "bosses": [
      {
        "enemy": "krol-kosci",
        "at": 180
      },
      {
        "enemy": "pradawny-nekromanta",
        "at": 390
      },
      {
        "enemy": "lodowy-wladca",
        "at": 600,
        "final": true
      }
    ],
    "hazards": {
      "kind": "lod",
      "perChunk": 3,
      "radius": [
        40,
        70
      ],
      "damagePerSecond": 0,
      "slow": 0.4
    },
    "breakables": 3,
    "recommendedPower": 1500
  }
]
